import type { ComponentType, SVGProps } from 'react'
import { Plug } from 'lucide-react'
import {
  AntigravityIcon,
  ChatGptIcon,
  ClaudeCodeIcon,
  ClaudeIcon,
  HermesIcon,
} from '../components/BrandIcons'

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>

export interface ClientBrand {
  icon: IconComponent
  /** Плитка под логотипом — цвет нейросети из токенов дизайн-системы. */
  tileClass: string
}

const CLAUDE_TILE = 'bg-claude/15 text-claude'

/**
 * Логотип подключения по названию клиента, которое сервер берёт из OAuth-регистрации
 * (`client_name`, у Claude Code — «Claude Code», у веб-Claude — «Claude»).
 * Порядок проверок важен: «Claude Code» тоже содержит «claude».
 * Незнакомый клиент — нейтральная вилка, без угаданного бренда.
 */
export const clientBrand = (clientName: string | null): ClientBrand => {
  const name = (clientName ?? '').toLowerCase()
  if (name.includes('claude code')) return { icon: ClaudeCodeIcon, tileClass: CLAUDE_TILE }
  if (name.includes('claude') || name === '') return { icon: ClaudeIcon, tileClass: CLAUDE_TILE }
  if (name.includes('chatgpt') || name.includes('openai'))
    return { icon: ChatGptIcon, tileClass: 'bg-foreground text-background' }
  if (name.includes('antigravity'))
    return { icon: AntigravityIcon, tileClass: 'bg-muted text-foreground' }
  if (name.includes('hermes') || name.includes('nous'))
    return { icon: HermesIcon, tileClass: 'bg-muted text-foreground' }
  return { icon: Plug, tileClass: 'bg-muted text-muted-foreground' }
}
